export enum SelectBoxLabel {
  NAME = 'Name',
  LAST_NAME = 'LastName',
  UserNameOrUserID = 'UserName/UserID',
  EmailOrUserID = 'Email/UserID',
}
